export const generateSearchParams = (obj) => {
  const searchParams = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    const objKey = key ;
    if (obj[objKey] !== undefined) {
      searchParams.append(key, String(obj[objKey]));
    }
  });
  return searchParams.toString();
};